import { get, post, put, deletefn } from "./service";
//精确查询 根据标题查询
export default {
  // post p=>data   get p=>params
  test1: (p) => get("", p),
  //登录
  login: (p) => post("login", p),

  //用户列表
  getList: (p) => get("/user/list", p),
  //修改密码
  updatePwd: (p) =>
    post("/user/update-pwd?id=" + p.id + "&password=" + p.password),
  //新增，修改用户
  addUpdataUser: (p) => post("/user/save", p),
  //删除用户
  userDelete: (p) => post("/user/delete?id=" + p),
  //AI组织列表
  aiOrgList: (p) => get("/ai-org/list", p),
  //AI组织删除
  aiOrgDelete: (p) => post(`/ai-org/delete?id=${p}`, p),
  //AI组织新增修改
  aiOrgSave: (p) => post("/ai-org/save", p),
  //AI用户列表
  aiUserList: (p) => get("/ai-user/list", p),
  //AI机构
  aiUserOrgList: (p) => get("/ai-user/orglist", p),
  //AI用户删除
  aiUserDelete: (p) => post(`/ai-user/delete?id=${p}`, p),
  //AI用户新增修改
  aiUserSave: (p) => post(`/ai-user/save`, p),
  //组织架构列表
  structureList: (p) => get("/org-structure/list-all", p),
  //组织架构列表(外部可访问)
  structureList1: (p) => get("/sso/org-list", p),

  // 第三方登录相关接口
  thirdLogin: (p) => get("/third-login/list", p),
  // 第三方登录相关接口  修改/新增
  thirdLoginChange: (p) => post("/third-login/save", p),
  // 第三方登录相关接口  删除
  thirdLoginDelet: (p) => post("/third-login/delete?id=" + p, {}),

  //组织机构新增修改
  addUpdataOrg: (p) => post("/org-structure/save", p),
  //删除当前组织
  orgDelete: (p) => post("/org-structure/delete?id=" + p),
  //父ID查科室
  structureSelect: (p) => get("/org-structure/select", p),
  //查询用户已有组织机构
  structureChildrenList: (p) => get("/org-structure/list-ownorg", p),

  //App用户管理列表
  AppUserList: (p) => get("/app-user/list", p),
  //修改密码
  AppupdatePwd: (p) => post("/app-user/update-pwd", p),
  //App用户用户同步情况
  AppUserInfo: (p) => get("/app-user/user-sync-info", p),
  //App用户用户同步错误列表
  AppUserInfoError: (p) => get("/app-user/user-sync-error-list", p),
  //App用户管理新增修改
  addUpdataAppUser: (p) => post("/app-user/save", p),
  //App删除用户
  appUserDelete: (p) => post("/app-user/delete?id=" + p),
  //微信解绑
  wxUntie: (p) => post("/app-user/wx-untie?id=" + p),
  //企业微信解绑
  qywxUntie: (p) => post("/app-user/qywx-untie?id=" + p),
  //批量同步
  synchronization: (p) => post("/app-user/batch-sync-user", p),
  //根据用户名批量删除
  batchDelete: (p) => post("/app-user/batch-delete?" + p),
  //异常同步&忽略
  synErrorUser: (p) => post("/app-user/batch-modify-error-user", p),
  //App用户统计权限列表
  AppUserAnalysisList: (p) => get("/app-user-authority/get-userid", p),
  //App用户统计权限开启/关闭
  AppUserAnalysisBool: (p) => post("/app-user-authority/save", p),

  //App应用管理列表
  AppRunList: (p) => get("/app/list", p),
  //App用户管理新增修改
  addUpdataAppRun: (p) => post("/app/save", p),
  //App删除用户
  appDelete: (p) => post("/app/delete?id=" + p),

  //用户注册
  register: (p) => post("/sso/register", p),
  //用户注册列表
  registerList: (p) => get("/app-user-register/list", p),
  //用户注册审核
  registerApply: (p) => post("/app-user-register/apply", p),
  //sso统一登录
  ssoLogin: (p) => post("/sso/login", p),
  // 自动登录
  autoLogin: (p) => get("/sso/login-auto", p),
  //验证码
  code: (p) => get("/sso/send-code", p),
  //获取微信相关信息
  wechatInfo: (p) => get("/sso/wechat-info", p),

  //登录统计
  stateLogin: (p) => get("/login-log/list", p),
  //登录日志统计导出
  exportStateLogin: (search, startTime, endDate, token) =>
    window.open(
      process.env.VUE_APP_API_URL +
        "sso/export/loginlog?search=" +
        search +
        "&startTime=" +
        startTime +
        "&endDate=" +
        endDate +
        "&token=" +
        token,
      "_blank"
    ),
  //登录统计导出
  exportStateTotalLogin: (search, usertype, intyear, token) =>
    window.open(
      process.env.VUE_APP_API_URL +
        "sso/export/logincollect?search=" +
        search +
        "&usertype=" +
        usertype +
        "&intyear=" +
        intyear +
        "&token=" +
        token,
      "_blank"
    ),
  //机构导出
  exportStateTotaljigou: (orgId, startYM, endYM, token) =>
    window.open(
      process.env.VUE_APP_API_URL +
        "sso/export/org-collect?orgId=" +
        orgId +
        "&startYM=" +
        startYM +
        "&endYM=" +
        endYM +
        "&token=" +
        token,
      "_blank"
    ),

  //登录汇总
  stateTotal: (p) => get("/login-collect/list", p),

  //医院汇总列表
  hospitalTotal: (p) => get("/login-collect/total-list", p),
  //医院汇总统计
  hospitalSumMore: (p) => get("/login-collect/org-total-list", p),

  //三方 点击数统计
  thirdSiteClick: (p) => get("/third-collect/click-page", p),

  //机构统计模块
  //删除用户
  jigouDelete: (p) => post("/org-collect/delete?id=" + p),
  //新增修改
  jigouAddAppUser: (p) => post("/org-collect/save", p),
  // 批量新增
  jigoupiliangAddAppUser: (p) => post("/org-collect/batch-save", p),
  //列表
  jigouTotal: (p) => get("/org-collect/list", p),

  //外文统计模块
  //登录统计
  foreignloginTotal: (p) => get("/ella-collect/operation-log", p),
  //登录汇总
  foreignloginState: (p) => get("/ella-collect/operation-collect", p),
  //数据统计
  foreignDataState: (p) => get("/ella-collect/data-collect", p),
  //医院汇总
  foreignHopState: (p) => get("/ella-collect/hos-collect", p),

  //导出用户
  exportUser: (search, orgCode, token) =>
    window.open(
      process.env.VUE_APP_API_URL +
        "sso/export/user?search=" +
        search +
        "&orgCode=" +
        orgCode +
        "&token=" +
        token,
      "_blank"
    ),
};
